export const inspireMeDropdownValue = 'INSPIRE';

export default null;
